module.exports = __webpack_public_path__ + "static/img/image003.ef2e835.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image003.png
// module id = ZV+o
// module chunks = 0